import type { ColumnMapping, IStatement } from "./SqliteDatabaseModel"

export const tableName = "messages_v1"

export interface SqliteMessageDataType {
  id?: number
  sid?: number
  message_id: string
  chat_id?: number
  chat_cid?: string
  sender_id?: number
  receiver_id?: number
  content?: string
  created: number
  updated: number
  attach?: string
  attach_path?: string
  type?: number
  status?: number
  read_ids?: string
  notify_type?: number
  mention_ids?: string
  reply_msg_id?: string
  forward_msg_id?: string
  forward_user_id?: number
  forward_name?: string
  burning_timer?: number
  is_deleted?: number
}

// 兼容旧签名：SqliteDatabaseModel 仍会接收 columMapping，但 Nitro SQLite 不需要它
export const columMapping: ColumnMapping<SqliteMessageDataType> = {} as any

export const genStatements = (tableName: string): IStatement => {
  return {
    [`1701670532060_create_${tableName}`]: `
      CREATE TABLE IF NOT EXISTS ${tableName} (
        id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT,
        sid NUMERIC UNIQUE,
        message_id TEXT,
        chat_id NUMERIC,
        chat_cid TEXT,
        sender_id NUMERIC,
        receiver_id NUMERIC,
        content TEXT,
        created NUMERIC,
        updated NUMERIC,
        attach JSON,
        attach_path TEXT,
        type NUMERIC,
        status NUMERIC,
        read_ids JSON,
        notify_type NUMERIC,
        mention_ids JSON,
        reply_msg_id TEXT,
        forward_msg_id TEXT,
        forward_user_id NUMERIC,
        forward_name TEXT,
        burning_timer NUMERIC,
        is_deleted BOOLEAN
      );`,
  }
}
